var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFiltersExpand = function SvgFiltersExpand(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 8v2h11v2H5v2H3v-2H0v-2h3V8h2zm8-8v2h3v2h-3v2h-2V4H0V2h11V0h2z",
    fill: "#0C6EFC",
    fillRule: "evenodd"
  })));
};
export default SvgFiltersExpand;